// extracted by mini-css-extract-plugin
export default {"wrapperInner":"Schedule_wrapperInner__58Xht","root":"Schedule_root__3dLZK","collapseContainer":"Schedule_collapseContainer__78kSU","note":"Schedule_note__1dzvA"};